<div class="tabs__header">
  <ng-container *ngIf="isRouterMode; else staticTabs">
    <a
      *ngFor="let tab of tabs; trackBy: trackByTab"
      class="tabs__tab"
      [class.tabs__tab--disabled]="tab.disabled"
      [routerLink]="tab.disabled ? null : tab.routerLink"
      routerLinkActive="tabs__tab--active"
    >
      <ng-container *ngIf="tab.labelTemplate; else defaultRouterLabel">
        <ng-container [ngTemplateOutlet]="tab.labelTemplate"></ng-container>
      </ng-container>
      <ng-template #defaultRouterLabel>{{ tab.label }}</ng-template>
    </a>
  </ng-container>

  <ng-template #staticTabs>
    <button
      *ngFor="let tab of tabs; let i = index; trackBy: trackByTab"
      class="tabs__tab"
      [class.tabs__tab--active]="i === activeIndex"
      [class.tabs__tab--disabled]="tab.disabled"
      [disabled]="tab.disabled"
      (click)="selectTab(i)"
    >
      <ng-container *ngIf="tab.labelTemplate; else defaultLabel">
        <ng-container [ngTemplateOutlet]="tab.labelTemplate"></ng-container>
      </ng-container>
      <ng-template #defaultLabel>{{ tab.label }}</ng-template>
    </button>
  </ng-template>
</div>

<div class="tabs__content" *ngIf="!isRouterMode">
  <ng-container *ngFor="let tab of tabs; let i = index; trackBy: trackByTab">
    <div *ngIf="i === activeIndex">
      <ng-container [ngTemplateOutlet]="tab.contentTemplate"></ng-container>
    </div>
  </ng-container>
</div>
